export default __webpack_public_path__ + "static/media/cenografia.a621d452.jpg";